<template>
<div class="flex w-full flex-col justify-between mobile-menu">
    <div class="mt-4 w-full">
        <!-- First level Menu -->
        <div class="flex flex-col pb-7">
            <div class="openable py-3" @mouseenter="openSubmenu('permits')"   @mouseleave="closeSubmenu()">
                <span class="flex justify-between items-center pl-l pr-8 h3-desk">Permisos<img src="/img/icons/menu/arrow-right.svg" class="arrow-right" alt="Button right"/></span>
                <!-- Second level Menu -->
                <div class="sub-menu xmd:-ml-4" v-bind:class="{active : subMenuActive == 'permits'}">
                    <side-menu-header @reset-type="() => closeSubmenu()" @close="closeAllLayers">
                        <p class="h4-desk">Permisos</p>
                    </side-menu-header>
                    <div class="sub-menu__content">
                        <p class="h4-desk uppercase font-bold">{{ $trans.get("global.car-permit") }}</p>
                        <div v-for="permit in carPermits" class="link">
                            <a :href="route('permit.landing', {'permit' : permit.slug[lang]})">{{ permit.description[lang] }}</a>
                        </div>
                        <p class="h4-desk uppercase font-bold mt-8">{{ $trans.get("global.motorbike-permit") }}</p>
                        <div v-for="permit in motoPermits" class="link">
                            <a :href="route('permit.landing', {'permit' : permit.slug[lang]})">{{ permit.description[lang] }}</a>
                        </div>
                        <p class="h4-desk uppercase font-bold mt-8">{{ $trans.get("global.other-permit") }}</p>
                        <div v-for="permit in otherPermits" class="link">
                            <a :href="route('permit.landing', {'permit' : permit.slug[lang]})" class="link">{{ permit.description[lang] }}</a>
                        </div>
                    </div>
                </div>
                <!-- ----------------- -->
            </div>
            <div class="openable py-3" @mouseenter="openSubmenu('courses')" @mouseleave="closeSubmenu()">
                <span class="flex justify-between items-center pl-l pr-8 h3-desk">Cursos<img src="/img/icons/menu/arrow-right.svg" class="arrow-right" alt="Button right"/></span>
                <!-- Second level Menu -->
                <div class="sub-menu xmd:-ml-4" v-bind:class="{active : subMenuActive == 'courses'}">
                    <side-menu-header @reset-type="() => closeSubmenu()" @close="closeAllLayers">
                        <p class="h4-desk">Cursos</p>
                    </side-menu-header>
                    <div class="sub-menu__content">
                        <p class="h4-desk uppercase font-bold">Cursos CAP</p>
                        <div v-for="course in capCourses" class="link" >
                            <a :href="route('course.landing', course.slug[lang])">{{ course.description[lang] }}</a>
                        </div>
                        <p class="h4-desk uppercase font-bold mt-8">Cursos ADR</p>
                        <div v-for="course in adrCourses" class="link" >
                            <a :href="route('course.landing', course.slug[lang])">{{ course.description[lang] }}</a>
                        </div>
                        <p class="h4-desk uppercase font-bold mt-8">{{ $trans.get('menu.other_courses') }}</p>
                        <div v-for="course in otherCourses" class="link">
                            <a :href="route('course.landing', course.slug[lang])" class="link">{{ course.description[lang] }}</a>
                        </div>
                    </div>
                </div>
                <!-- ----------------- -->
            </div>
            <div class="openable py-3" @mouseenter="openSubmenu('services')" @mouseleave="closeSubmenu()">
                <span class="flex justify-between items-center pl-l pr-8 h3-desk">{{ $trans.get("menu.other_services") }}<img src="/img/icons/menu/arrow-right.svg" class="arrow-right" alt="Button right"/></span>
                <!-- Second level Menu -->
                <div class="sub-menu xmd:-ml-4" v-bind:class="{active : subMenuActive == 'services'}">
                    <side-menu-header @reset-type="() => closeSubmenu()" @close="closeAllLayers">
                        <p class="h4-desk lg:hidden">{{ $trans.get("menu.other_services") }}</p>
                    </side-menu-header>
                    <div class="sub-menu__content">
                        <p class="h4-desk uppercase">{{ $trans.get('aula.routes.results.title') }}</p>
                        <a class="hover:underline" href="https://sedeclave.dgt.gob.es/WEB_NOTP_CONSULTA/consultaNota.faces">{{ $trans.get('aula.routes.results.description') }}</a>
                        <p class="h4-desk mt-[30px] uppercase">{{ $trans.get('aula.routes.card.title') }}</p>
                        <a class="hover:underline" href="https://sedeapl.dgt.gob.es/WEB_EST_PERSEO/">{{ $trans.get('aula.routes.card.description') }}</a>
                        <p class="h4-desk mt-[30px] uppercase">{{ $trans.get('aula.routes.points.title') }}</p>
                        <a class="hover:underline" href="https://sedeapl.dgt.gob.es:7443/WEB_COPACI3/consultarPuntos.faces">{{ $trans.get('aula.routes.points.description') }}</a>
                        <p class="h4-desk mt-[30px] uppercase">{{ $trans.get('titles.mediation') }}</p>
                        <a class="hover:underline" :href="route('mediation')">{{ $trans.get('titles.mediation-description') }}</a>
                        <p class="h4-desk mt-[30px] uppercase">test AEOL</p>
                        <a class="hover:underline" href="https://cloud.aeolservice.es">{{ $trans.get('titles.aeol-description') }}</a>
                        <p class="h4-desk mt-[30px] uppercase">{{ $trans.get('titles.jobs') }}</p>
                        <a class="hover:underline" :href="route('jobs')">{{ $trans.get('titles.jobs-description') }}</a>
                    </div>
                </div>
                <!-- ----------------- -->
            </div>

        </div>
         <!-- ----------------- -->
		<div class="btn-red lg:mt-8 mt-4 px-4 py-3 rounded-md ml-l cursor-pointer">
            <a href="https://app.practicavial.com/p/121" class="flex "><img src="/img/icons/menu/user.svg" class="mr-4" alt="Close">{{$trans.get('global.student-area')}}</a>
        </div>
        <div class="lg:mt-16 mt-12">
            <div class="flex flex-col">
              <a class="py-2 px-l" :href="route('autoescoles.index')">{{$trans.get('maps.schools_map')}}</a>
              <a class="py-2 px-l" :href="route('about')">{{$trans.get("menu.about-us")}}</a>
              <a class="py-2 px-l" :href="route('blog')">Blog</a>
              <a class="py-2 px-l" :href="route('faq')">FAQ</a>
              <a class="py-2 px-l" :href="route('join-us')">{{$trans.get("menu.join-us")}}</a>
              <a class="py-2 px-l" :href="route('contacte')">{{$trans.get('_footer.contact')}}</a>
            </div>
            <div class="flex flex-col mt-12">
			  <a :href="route('matriculats')" class="flex py-2 px-l"><img src="/img/icons/menu/tv-3.svg" class="w-8 mr-4" alt="Matriculats">{{$trans.get('matriculats.title')}}</a>
              <a :href="route('podcast')" class="flex py-2 px-l"><img src="/img/icons/menu/fricando.svg" class="w-8 mr-4" alt="Podcast">Podcast</a>
              <a :href="route('videos')" class="flex py-2 px-l"><img src="/img/icons/menu/video.svg" class="w-8 mr-4" alt="Video">{{$trans.get("titles.video")}}</a>
            </div>
            <div class="px-l mt-xxl pb-xl flex justify-start xlg:hidden">
             <slot></slot>
            </div>
        </div>
    </div>
	</div>
</template>

<script>
import SideMenuHeader from './SideMenuHeader.vue';

export default {
	props: ['closeMenu', 'carPermits', 'motoPermits', 'otherPermits', 'capCourses', 'adrCourses', 'otherCourses'],
	components: {
		SideMenuHeader
	},
	data() {
        return {
            cursos: false,
            permisos: false,
            servicios: false,
            subMenuActive: '',
            services: [
                'points',
                'mediation'
            ]
        };
	},
	methods:{
        openSubmenu(layer){
            this.subMenuActive = layer;
        },
        closeSubmenu(){
            this.subMenuActive = ''
        },
        closeAllLayers(){
            this.closeSubmenu()
            this.closeMenu()
        },

	},
    watch: {
        isActive: function (val) {
            const body = document.getElementsByTagName('body')[0]
            console.log(body);
            if (val) body.style.overflow = 'hidden'
            else body.style.overflow = ''
        },
	},
};
</script>

<style lang="scss" scoped>
@import "~sass/variables";

.btn-red{
    width: fit-content;
    margin-left: 20px;
    background-color: $watermelon;
    &:hover {
       text-decoration: underline;
    }
}

.sub-menu__content {
  overflow-y: auto; 
  max-height: 100%; 
  scrollbar-width: none; 
}

.sub-menu__content::-webkit-scrollbar {
  display: none; 
}


</style>
